import React from "react";
import { Controller, FieldValues, UseControllerProps } from "react-hook-form";

import { Flex, MiniTag, Toggle, Typography } from "@/components/Elements";

export function NotificationDetailsHeader<T extends FieldValues>(
  props: UseControllerProps<T>,
) {
  return (
    <Flex
      justifySpaceBetween
      alignCenter
      className="notification-details--header"
    >
      <Typography
        label="Notification Details"
        color="generalMidnightDark"
        size="lg"
        weight="semiBold"
      />
      <Controller
        control={props.control}
        name={props.name}
        render={({ field: { value, onChange } }) => (
          <Flex columnGap={8}>
            <MiniTag label="Disabled" theme={value ? "gray" : "red"} />
            <Toggle size="sm" active={value} onChange={onChange} />
            <MiniTag label="Enabled" theme={value ? "green" : "gray"} />
          </Flex>
        )}
      />
    </Flex>
  );
}
